import * as React from 'react'
import { styled } from '@mui/material/styles'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'
import { Typography } from '@mui/material'

interface StyledTabsProps {
  children?: React.ReactNode
  value: number
  onChange: (event: React.SyntheticEvent, newValue: number) => void
}

const StyledTabs = styled((props: StyledTabsProps) => (
  <Tabs {...props} TabIndicatorProps={{ children: <span className='MuiTabs-indicatorSpan' /> }} />
))({
  '& .MuiTabs-indicator': {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  '& .MuiTabs-indicatorSpan': {
    // maxWidth: 40,
    width: '100%',
    backgroundColor: '#FF3839',
  },
})

interface StyledTabProps {
  label: string | JSX.Element
}

const StyledTab = styled((props: StyledTabProps) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    color: '#FFFFFF',
    '&.Mui-selected': {
      color: '#FFFFFF',
    },
    '&.Mui-focusVisible': {
      backgroundColor: 'rgba(100, 95, 228, 0.32)',
    },
  }),
)

type TabComponentProps = {
  options: string[]
  activeIndex: number
  onTabIndexChange: (index: number) => void
}

export default function TabComponent({
  options,
  activeIndex,
  onTabIndexChange,
}: TabComponentProps) {
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    onTabIndexChange(newValue)
  }

  return (
    <Box sx={{ borderBottom: 1, borderColor: '#191919' }}>
      <StyledTabs value={activeIndex} onChange={handleChange} aria-label='styled tabs example'>
        {options.map((option) => {
          return <StyledTab label={<Typography variant='h5'>{option}</Typography>} key={option} />
        })}
      </StyledTabs>
    </Box>
  )
}
